import { render, staticRenderFns } from "./PainelConfiguracoes.vue?vue&type=template&id=c160bfa4&scoped=true"
import script from "./PainelConfiguracoes.vue?vue&type=script&lang=js"
export * from "./PainelConfiguracoes.vue?vue&type=script&lang=js"
import style0 from "./PainelConfiguracoes.vue?vue&type=style&index=0&id=c160bfa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c160bfa4",
  null
  
)

export default component.exports